import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useRbacState } from '../context/rbac.context';
import { getSafeLandingPath } from '../utils/rbacLandingPaths';
import { isGuardianUserRole } from '../utils/guardianAuth';

export const useRbacSafeLandingPath = (): string => {
  const { rbac } = useRbacState();
  const location = useLocation();
  return useMemo(
    () =>
      getSafeLandingPath(rbac as Record<string, unknown> | null, {
        isGuardian: isGuardianUserRole(),
        currentPathname: location.pathname,
      }),
    [rbac, location.pathname]
  );
};
